module.exports = __webpack_public_path__ + "img/fk.0d361798.svg";